const CHUNK_RELOAD_KEY = 'zkai_chunk_reload_guard'
const RELOAD_GUARD_MS = 60 * 1000

const buildErrorText = (error) => {
    if (!error) return ''
    if (typeof error === 'string') return error
    return [
        error.name,
        error.message,
        error.stack,
        error.filename,
        error?.target?.src,
        error?.target?.href
    ].filter(Boolean).join(' ')
}

export const isChunkLoadError = (error) => {
    const text = buildErrorText(error)
    if (!text) return false

    const hasChunkSignal = /ChunkLoadError|Loading chunk \d+ failed|Loading CSS chunk \d+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(text)
    if (hasChunkSignal) return true

    const hasHtmlAsJsSignal = /Unexpected token ['"]?</i.test(text)
    const hasBuiltAssetUrl = /\/assets\/(js|css)\//i.test(text)
    return hasHtmlAsJsSignal && hasBuiltAssetUrl
}

export const recoverFromChunkLoadError = (error, options = {}) => {
    if (!isChunkLoadError(error) || typeof window === 'undefined') {
        return false
    }

    const target = options.target || window.location.href
    const now = Date.now()
    let lastReload = null
    try {
        lastReload = JSON.parse(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 'null')
    } catch (parseError) {
        lastReload = null
    }

    if (lastReload && lastReload.target === target && now - Number(lastReload.time || 0) < RELOAD_GUARD_MS) {
        console.error('页面资源加载失败，已尝试刷新但仍未恢复：', error)
        return true
    }

    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, JSON.stringify({
        target,
        time: now
    }))
    window.location.reload()
    return true
}
